import type { FaireProductEntity } from "../../entity_types/product";

export const p_cqp6enyset: FaireProductEntity = {
  token: "p_cqp6enyset",
  type: "product",
  name: "Mahjong Mat, Neoprene, Spring Collection",
  brandToken: "b_1bc8bhtc7s",
  brandName: "Boutique Monogram",
  imageUrl:
    "https://cdn.faire.com/fastly/f8b3ac3fd92580139e3d9ac8feae9cf8bf6edc08eb3113bb31e3c27104dcccff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8cfc5aa20e112e5336f1fbe9fb26cc01cda0663006b2c3d3a952fe7d85a22b39.jpeg",
    "https://cdn.faire.com/fastly/0f62f4f475c0130bc369a827eb0dda43fdbdf92c1b1645142b9dfa383a4d8eea.jpeg",
    "https://cdn.faire.com/fastly/8bed6eb224a6da58d2bdbe3676af15e3729d9a65972d8ded0e6e364366af983f.jpeg",
    "https://cdn.faire.com/fastly/7e9e10c3a2e92ad1a717bbd524902e2f4e613b06777f59c11be9e64ef752d704.jpeg",
    "https://cdn.faire.com/fastly/d4d995ec1ab0a8a18fc4a28cda4bf497b1bbb5275aafc2734c91501c2e01231a.jpeg",
    "https://cdn.faire.com/fastly/db7abcd653d0a6382d04299cb727b8f3cdd8a4aa9ed035968a6cbc7813772ffd.jpeg",
    "https://cdn.faire.com/fastly/7c72d8c9d50e795549e4ff669505868c079f9514a39c64ea008ca12c6753ef2a.jpeg",
    "https://cdn.faire.com/fastly/1ddb52c7533205b3f48e5f8019f020a04c5441fea962350549c80a531afc4396.jpeg",
    "https://cdn.faire.com/fastly/2973d2e8d8d69888b31c3f6e2c6286230758f41c75823b1132f87434312c90c0.jpeg",
    "https://cdn.faire.com/fastly/387421b1eab26c3895182b817b4f78914c37376ffe50afd95edbdfd22cca2c44.jpeg",
    "https://cdn.faire.com/fastly/006e6c23ab947c067dadc994607b6dced9df1ca98d01ca5c5dc5f23031bfacfa.jpeg",
    "https://cdn.faire.com/fastly/12d573555860a8dfc9fe16e86bf033aa99517712702d43aba27fb1645b40b796.jpeg",
    "https://cdn.faire.com/fastly/16e6d15541f82d7961037f81576d7f444b54c6e522129b2bff194b968380fab4.jpeg",
    "https://cdn.faire.com/fastly/2f2441d9e997fbf381648f84dd67e807ac650815b29d392cea13192e7f0e896f.jpeg",
    "https://cdn.faire.com/fastly/65e04f37fbc9d3a992990f19dcdfc832ef17d7e616321cc27e9deb71572ebc1d.jpeg",
    "https://cdn.faire.com/fastly/b192fa59603d4fad6c22cdbeb42576e364027ffa90dd60332f528d2894717244.jpeg",
    "https://cdn.faire.com/fastly/a6fefc8c5924134744ab59b4ab6293d6816ee6ef9a4182b8a66617e87e5798fc.jpeg",
    "https://cdn.faire.com/fastly/1e1bb928b3b992511da617a531138321c7205a5d2b0ee445fd5584a858f0136e.jpeg",
  ],
  priceDollars: 39.99,
  description:
    '🇺🇸 Handmade in the USA\n\n🗒️ PRODUCT DETAILS\n· 31.5" x 31.5" premium neoprene mahjong mat\n· 3mm thick for a comfortable, cushioned playing surface\n· Soft polyester fabric top with a non-slip rubber backing\n· Professionally printed with vibrant, long-lasting colors that won\'t fade or peel\n· Optional matching carrying bag available\n\n📦 PRODUCTION & SHIPPING\n· Handmade to order in 3–5 business days\n· Ships rolled to help preserve quality during transit\n· Proudly made and shipped from the USA\n\n⚠️ CANCELLATION POLICY\nBecause each item is handmade specifically for your order, cancellations and refunds are accepted only within 1 hour of purchase. After that time, production begins and the order cannot be canceled.\nFaire offers FREE returns.\n\nDesign Copyright © Boutique Monogram. All rights reserved.',
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:44.974Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
